// Path: src\Components\CustomerCare\RaiseAComplaint.jsx
import React, { useCallback, useEffect, useState } from "react";
import TextInput from "../CommonFields/TextInput";
import Button from "../CommonFields/Button";
import CategoryDropDown from "./CategoryDropDown";
import { FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { base_apis } from "../../config/url";
import { useDropzone } from "react-dropzone";
import RequestSubmitPopup from "./RequestSubmitPopup";
import { routesFrontend } from "../RouterFiles/routes";
import { useNavigate } from "react-router";
import TimeSlotPopup from "./TimeSlotPopup";
import CallbackMobile from "./CallbackMobile";
import { customerCareCategory, customerCareGames, customerCareJoinedContest, customerCareTimeSlot } from "../../api/custom-care.api";
import { getUserSubscriptionDetails } from "../../api/subscription.api";
import { formatDate, formatTime } from "../../Utilities/helper";
import { toastError, toastInfo } from "../../Utilities/toast";
import { t } from "i18next";
import { createTicket } from "../../api/customerCare.api";
import InputAdornment from '@mui/material/InputAdornment';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'; // Import the down arrow icon
import moment from "moment";

const RaiseAComplaint = () => {
  const navigate = useNavigate();
  const [timeSlot, setTimeSlot] = useState(null);
  const [name, setName] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [description, setDescription] = useState("");
  const [email, setEmail] = useState("");
  const [category, setCategory] = useState(null);
  const [subCategory, setSubCategory] = useState(null);
  const [game, setGame] = useState(null);
  const [match, setMatch] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [subCategoryError, setSubCategoryError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [gameError, setGameError] = useState("");
  const [matchError, setMatchError] = useState("");
  const [showDropDown, setShowDropDown] = useState(false);
  const [showsubcategoryDropDown, setshowsubcategoryDropDown] = useState(false);
  const [showGameDropDown, setGameDropDown] = useState(false);
  const [showMatchDropDown, setMatchDropDown] = useState(false);
  const [files, setFiles] = useState(null); //for image upload
  const [showRequestSubmitPopup, setRequestSubmitPopup] = useState(false);
  const [showTimeSlotPopup, setTimeSlotPopup] = useState(false);
  const [showCallBackMObile, setCallBackMObile] = useState(false);
  const [payloadInfo, setPayloadInfo] = useState([])

  const [categoryList, setCategoryList] = useState([]);
  const [subcategoryList, setSubCategoryList] = useState([]);
  const [gameList, setGameList] = useState([]);
  const [matchesList, setMatchesList] = useState([]);
  const [timeslotsList, setTimeSlotList] = useState([]);

  const [isPremiumUsers, setIsPremiumUser] = useState(false);
  const [isFormValiate, setIsFormValidate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    try {
      // var isPremium = JSON.parse(localStorage.getItem('profileLite'))?.subscriptionDetails?.isPremium || false
      setIsPremiumUser(localStorage?.getItem('premiumUser') === "true" ? true : false)
      setName(JSON.parse(localStorage.getItem('profile'))?.gamerjiName || '')
      setMobileNo(JSON.parse(localStorage.getItem('profile'))?.phone || '')
      setEmail(JSON.parse(localStorage.getItem('profile'))?.email || '')
    } catch (error) { }
    fetchCustomerCareCategory(true);

  }, [])

  const fetchCustomerCareCategory = async (isParent) => {
    try {
      var payload = { pagination: { pageNo: 1, recordPerPage: 100 } }
      if (isParent === false) {
        payload.search = { parent: category?.value };
      } else {
        payload.search = { isParent: true }
      }
      var response = await customerCareCategory(payload);
      if (response?.success && response?.data) {
        let tempCategory = [];
        response?.data?.map((item) => {
          tempCategory.push({ label: item?.label, value: item?._id, isContestDependency: item?.isContestDependency })
        })
        if (isParent) { setCategoryList(tempCategory) }
        else { setSubCategoryList(tempCategory) }
      } else {
        if (isParent) { setCategoryList([]); setCategory(null) }
        else { setSubCategoryList([]); setSubCategory(null) }
      }
    } catch (error) { }
  }
  const fetchCustomerCareGames = async () => {
    try {
      var response = await customerCareGames({});
      if (response?.success && response?.data) {
        let tempCategory = [];
        response?.data?.map((item) => {
          tempCategory.push({ label: item?.name, value: item?._id })
        })
        setGameList(tempCategory);
        setGame(null)
      } else {
        setGameList([])
        setGame(null)
      }
    } catch (error) { }
  }

  const fetchCustomerCareMatches = async () => {
    try {
      var response = await customerCareJoinedContest({ game: game?.value });
      if (response?.success && response?.data) {
        let tempCategory = [];
        response?.data?.map((item) => {
          tempCategory.push({ label: item?.gameType, value: item?._id, type: item?.type, dateTime: item?.dateTime })
        })
        setMatchesList(tempCategory);
        setMatch(tempCategory[0])
      } else {
        setMatchesList([])
        setMatch(null)
      }
    } catch (error) { }
  }

  const fetchTimeSlot = async () => {
    try {
      var response = await customerCareTimeSlot();
      if (response?.success && response?.data) {
        setTimeSlotPopup(true)
        setTimeSlotList(response?.data);
      } else {
        setTimeSlotList([]);
      }
    } catch (error) { }
  }

  const [activeMatch, setActiveMatch] = useState(0)
  const [uploadLoader, setUploadLoader] = useState(t("crm.upload_screenshot"));
  const onDrop = useCallback((acceptedFiles) => {
    setUploadLoader("Please wait, Uploading...");
    var formData = new FormData();
    console.log(acceptedFiles.length);
    formData.append("file", acceptedFiles[0], "[PROXY]");

    var requestOptions = {
      method: "POST",
      headers: { "x-access-token": localStorage.getItem("viToken") },
      body: formData,
      redirect: "follow",
    };

    fetch(`${base_apis.customercare}/upload`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setFiles(result?.item?.screenShot);
        setUploadLoader("");
        setIsImageUploaded(true);
      })
      .catch((error) => {
        setUploadLoader("");
      });
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      'image/*': ['.jpg', '.jpeg', '.png', '.webp']
    }
  });
  const [uploadLoaderImageAttached, setUploadLoaderImageAttached] = useState(
    "Image File Attached"
  );
  const [imagemessage, setimagemessage] = useState(
    t("crm.please_upload_screenshot_of_your_game")
  );
  const [imagemessageImageAttached, setimagemessageImageAttached] = useState(
    "Screenshot uploaded successfully"
  );
  const [isImageUploaded, setIsImageUploaded] = useState(false);


  const handlerChange = () => {
    // console.log("clicked")
    if (email.length == 0) {
      setEmailError("enter email");
    }
    if (category.length == 0) {
      setCategoryError("enter category");
    }
    if (subCategory.length == 0) {
      setSubCategoryError("enter subcategory");
    }
    if (game.length == 0) {
      setGameError("enter game");
    }
  };

  useEffect(() => {
    if (category) {
      fetchCustomerCareCategory(false);
      setCategoryError('')

      setSubCategoryList([])
      setGameList([])
      setMatchesList([])
      setSubCategory(null)
      setGame(null)
      setMatch(null)
    }
  }, [category])
  useEffect(() => {
    if (subCategory) {
      fetchCustomerCareGames();
      setSubCategoryError('')
    }
  }, [subCategory])
  useEffect(() => {
    if (game) {
      fetchCustomerCareMatches();
      setGameError('')
    }
  }, [game])
  useEffect(() => {
    if (match) {
      setMatchError('')
    }
  }, [match])
  useEffect(() => {
    if (description) {
      setDescriptionError('')
    }
  }, [description])
  const getCategoryTitle = (title) => {
    const selected = categoryList.find((item) => item.label === title);
    setCategory(selected);
    setShowDropDown(false);
  };
  const getSubCategoryTitle = (title) => {
    const selected = subcategoryList.find((item) => item.label === title);
    console.log(selected)
    setSubCategory(selected);
    setshowsubcategoryDropDown(false);
  };
  const getGameTitle = (title) => {
    const selected = gameList.find((item) => item.label === title);
    setGame(selected);
    setGameDropDown(false);
  };

  const handlerMatch = (e) => {
    setActiveMatch(e.target.value)
    const selected = matchesList[e.target.value] //.find((el) => `${el.label} - ${formatDate(el?.dateTime)} - ${formatTime(el?.dateTime)}` === e.target.value);
    setMatch(selected);
  }
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  useEffect(() => {
    var isValidate = true;
    if (category === undefined && category === null) {
      console.log(1)
      isValidate = false;
    }
    if (email === undefined || email === null || email.trim() === '') {
      console.log(1)
      isValidate = false;
    } else if (!validateEmail(email)) {
      isValidate = false;
      setEmailError(t("customer_care.error_email_valid"));
    } else {
      setEmailError('');
    }

    if (subcategoryList.length > 0 && (subCategory === undefined || subCategory === null)) {
      console.log(2)
      isValidate = false;
    }
    if (subCategory?.isContestDependency)
      if ((game === undefined || game === null)) {
        console.log(3)
        isValidate = false;
      }
    if (subCategory?.isContestDependency)

      if ((match === undefined || match === null)) {
        console.log(4)
        isValidate = false;
      }
    if ((description === undefined || description === null || description === '')) {
      isValidate = false;
      console.log(5)
    }
    setIsFormValidate(isValidate);
  }, [category, email, subCategory, game, match, name, email, mobileNo, description])
  useEffect(() => {
    if (timeSlot)
      handleSubmitBtn();
  }, [timeSlot])
  const handleSubmitBtn = async (isRequestCallback) => {
    try {
      if (isLoading) return;

      if (email === undefined || email == null || email.trim() === '') {
        setEmailError(t('customer_care.error_email_required'))
      }
      console.log(category)
      if (category === undefined || category == null) {
        setCategoryError(t('customer_care.error_category'))
      }
      if ((subCategory === undefined || subCategory === null)) {
        setSubCategoryError(t("customer_care.error_sub_category"));
      }
      if ((game === undefined || game === null)) {
        setGameError(t("customer_care.error_game"));
      }
      if ((match === undefined || match === null)) {
        setMatchError(t("customer_care.error_match"));
      }
      if ((description === undefined || description === null || description.trim() === '')) {
        setDescriptionError(t("customer_care.error_description_required"));
      }

      if (!isFormValiate) return;
      if (isRequestCallback) {
        setCallBackMObile(true)
        return

      }
      var payload = {}
      payload.category = category?.value;
      payload.customerCareCategoryName = category?.label;
      payload.description = description
      payload.name = name
      payload.email = email
      payload.phone = mobileNo
      payload.phoneCode = JSON.parse(localStorage.getItem('profileLite'))?.phoneCode || '+91'
      payload.isActive = true
      payload.isSingle = match?.type === "Tournament" ? false : true
      if (match !== null) {
        payload.gametypeName = match?.label
        payload.gametype = match?.value
      }
      payload.game = game?.value
      console.log(subCategory)
      if (subCategory !== null) {
        payload.subCategoryName = subCategory?.label
        payload.subCategory = subCategory?.value
      }
      if (timeSlot !== null) {
        payload.timeSlotId = timeSlot?.timeSlotId?._id
        payload.callDate = moment(timeSlot?.callDate).format("YYYY/MM/DD")
        payload.callTime = timeSlot?.callTime
        payload.isCallRequest = true
      }

      payload.userPlatform = "webPortal"
      payload.userVersion = "0.0.1"
      if (files) {
        payload.screenShot = files
      }
      setIsLoading(true)
      var response = await createTicket(payload);
      setPayloadInfo(payload)
      setIsLoading(false)
      if (response?.success) {
        if (timeSlot !== null) {
          setRequestSubmitPopup(true)
        } else {
          toastInfo(t("customer_care.message_ticket_created"))
          navigate(-1)
        }
      } else {
        toastError(response?.data?.errors[0]?.msg)
      }
    } catch (error) {
      setIsLoading(false)
    }
  }
  const handleFileInputClick = () => {
    document.getElementById("hiddenFileInput").click();
  };

  return (
    <div className="">
      <div className="raise-a-complaint scroll-none" style={{ paddingTop: "0px" }}>
        <div className="mt-3 inputFieldBottomMarging">
          <TextInput
            labelName={t("crm.name")}
            placeholder={"enter name"}
            inputLength="32"
            readOnly={true}
            defaultValue={name}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="inputFieldBottomMarging">
          <TextInput
            labelName={t("crm.mobile_number")}
            placeholder={""}
            defaultValue={mobileNo}
            value={mobileNo}
            onChange={(e) => setMobileNo(e.target.value)}
            readOnly={true}
          />
        </div>
        <div className="inputFieldBottomMarging">
          <TextInput
            labelName={t("crm.email")}
            placeholder={"enter email"}
            value={email.trim()}
            onChange={(e) => setEmail(e.target.value.trim())}
            helperText={emailError}
          />
        </div>
        <div className="inputFieldBottomMarging">
          <TextField
            label={t("crm.select_category")}
            placeholder="select category"
            value={category ? category?.label : ''}
            helperText={categoryError}
            autoComplete="off"
            onMouseDown={(e) => { e.preventDefault(); }}
            onClick={() => setShowDropDown(true)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" onClick={() => setShowDropDown(!showDropDown)}> {/* Toggle dropdown on click */}
                  <KeyboardArrowDownIcon sx={{ fill: '#82838E', cursor: 'pointer' }} />
                </InputAdornment>
              ),
            }}
          />

          {showDropDown && (
            <CategoryDropDown
              cancel={true}
              getTitle={getCategoryTitle}
              showDropDownValues={() => setShowDropDown(false)}
              values={categoryList.map((el) => el.label)}
              isOpen={showDropDown}
              title="Select Category"
            />
          )}
        </div>
        {
          category && (
            <div className="inputFieldBottomMarging">
              <TextField
                id="outlined-required"
                label={t("crm.select_sub_category")}
                placeholder="select sub category"
                value={subCategory ? subCategory?.label : ''}
                helperText={subCategoryError}
                autoComplete="off"
                onMouseDown={(e) => { e.preventDefault(); }}
                onClick={() => setshowsubcategoryDropDown(true)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      onClick={() => setshowsubcategoryDropDown(!showsubcategoryDropDown)} // Toggle dropdown on click
                    >
                      <KeyboardArrowDownIcon sx={{ fill: '#82838E', cursor: 'pointer' }} />
                    </InputAdornment>
                  ),
                  readOnly: true,
                  tabIndex: -1,
                }}
              />

              {(showsubcategoryDropDown && subcategoryList.length > 0) && (
                <CategoryDropDown
                  cancel={true}
                  getTitle={getSubCategoryTitle}
                  showDropDownValues={() => setshowsubcategoryDropDown(false)}
                  values={subcategoryList.map((el) => el.label)}
                  isOpen={showsubcategoryDropDown}
                  title="select sub Category"
                />
              )}
            </div>)
        }

        {
          subCategory?.isContestDependency ?
            (<div className="inputFieldBottomMarging mt-3">
              <TextField
                id="outlined-number"
                label={t("crm.select_game")}
                placeholder={t("crm.select_game")}
                slotProps={{ inputLabel: { shrink: true }, }}
                // onClick={(e) => setGameDropDown(true)}
                value={game ? game?.label : ''}
                helperText={gameError}
                onClick={() => setGameDropDown(true)}
                onMouseDown={(e) => { e.preventDefault(); }}
                // readOnly={true}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      onClick={() => setGameDropDown(!showGameDropDown)} // Toggle dropdown on click
                    >
                      <KeyboardArrowDownIcon sx={{ fill: '#82838E', cursor: 'pointer' }} />
                    </InputAdornment>
                  ),
                  readOnly: true,
                  tabIndex: -1,
                }}
              />
              {(showGameDropDown && gameList.length > 0) && (
                <CategoryDropDown
                  cancel={true}
                  getTitle={getGameTitle}
                  showDropDownValues={() => setGameDropDown(false)}
                  values={gameList.map((el) => el.label)}
                  isOpen={showGameDropDown}
                  title="select game"
                />
              )}
            </div>) : <></>
        }
        {
          subCategory?.isContestDependency ?
            (<div className="position-relative inputFieldBottomMarging" style={{ marginTop: "2.5rem" }}>
              <span className="label f-12">{t("crm.select_match")}</span>
              <div className={matchesList?.length === 0 ? 'mb-4 textfield-radio scroll-none heightMinNoData mt-4' : matchesList?.length === 1 ? 'mb-4 textfield-radio scroll-none heightMin mt-4' : "mb-4 textfield-radio scroll-none mt-4"}>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={activeMatch}
                  name="radio-buttons-group"
                  onChange={handlerMatch}
                  className={matchesList?.length > 1 ? "text-radio-box" : 'text-radio-box bottom-border'}
                >
                  {
                    matchesList?.map((time, index) => {
                      return (
                        <FormControlLabel value={index} control={<Radio />} label={`${time.label} - ${formatDate(time?.dateTime)} - ${formatTime(time?.dateTime)}`} />
                      )
                    })
                  }
                </RadioGroup>
              </div>
            </div>) : <></>
        }


        <div className="mb-4 crm-text-area" style={{ marginTop: "2.2rem" }}>
          <TextField
            id="outlined-multiline-static"
            label={t("crm.describe_your_issue_here")}
            multiline
            rows={4}
            defaultValue=""
            helperText={descriptionError}
            onChange={(e) => setDescription(e.target.value)}

          />
        </div>
        <div className="img_upd_btn" style={{ marginTop: '2rem' }} onClick={() => handleFileInputClick()}>
          <input
            type="file"
            accept="image/*"
            id="hiddenFileInput"
            multiple
            style={{ display: "none" }}
            onChange={(e) => onDrop(e.target.files)}
          />

          <div className="upload_ss d-flex flex-column justify-content-center align-items-center">
            {!files ? (
              <div>
                <div>
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      opacity="0.4"
                      cx="20"
                      cy="20"
                      r="20"
                      fill="#082240"
                    />
                    <g clip-path="url(#clip0_969_9681)">
                      <path
                        d="M29.5205 14.0564V29.4723C29.5205 29.7371 29.4688 29.9993 29.3683 30.2439C29.2678 30.4886 29.1205 30.7109 28.9349 30.8981C28.7492 31.0854 28.5287 31.2339 28.2861 31.3352C28.0435 31.4366 27.7835 31.4887 27.5209 31.4887H14.5437C14.0133 31.4887 13.5047 31.2763 13.1297 30.8981C12.7547 30.52 12.5441 30.0071 12.5441 29.4723V21.0798H20.5267V12.9931H12.5441V10.5268C12.5441 9.99204 12.7547 9.47915 13.1297 9.10099C13.5047 8.72282 14.0133 8.51038 14.5437 8.51038H24.1804L24.2306 8.562L24.1804 8.61065V13.0477C24.1802 13.1802 24.206 13.3114 24.2563 13.4338C24.3065 13.5563 24.3802 13.6675 24.4731 13.7612C24.566 13.8549 24.6763 13.9292 24.7977 13.9799C24.9191 14.0305 25.0493 14.0565 25.1807 14.0564H29.4201L29.4713 14.0058L29.5205 14.0564Z"
                        fill="#00ACEA"
                      />
                      <path
                        d="M29.4733 14.0067L29.4221 14.0574H25.1807C25.0493 14.0575 24.9192 14.0315 24.7978 13.9808C24.6764 13.9302 24.566 13.8559 24.4731 13.7622C24.3802 13.6685 24.3065 13.5572 24.2563 13.4348C24.2061 13.3124 24.1803 13.1811 24.1804 13.0486V8.61359L24.2306 8.56494L29.4733 14.0067Z"
                        fill="#FEDB41"
                      />
                      <path
                        d="M20.5277 12.993V21.0798H10.4795V12.993H20.5277Z"
                        fill="#00EFD1"
                      />
                      <path
                        d="M17.0593 16.9208L15.9999 15.8853V19.3543C15.9999 19.488 15.9472 19.6163 15.8534 19.7109C15.7596 19.8055 15.6324 19.8586 15.4997 19.8586C15.3671 19.8586 15.2399 19.8055 15.1461 19.7109C15.0523 19.6163 14.9996 19.488 14.9996 19.3543V15.8843L13.9402 16.9198C13.8442 17.0082 13.7178 17.0553 13.5879 17.0513C13.4579 17.0473 13.3346 16.9924 13.2441 16.8983C13.1536 16.8042 13.103 16.6783 13.103 16.5472C13.103 16.4161 13.1536 16.2901 13.2442 16.196L15.1532 14.3325C15.2465 14.2413 15.3713 14.1903 15.5012 14.1903C15.6311 14.1903 15.756 14.2413 15.8493 14.3325L17.7563 16.197C17.8058 16.2425 17.8457 16.2976 17.8737 16.359C17.9017 16.4203 17.9171 16.4867 17.9192 16.5542C17.9212 16.6217 17.9098 16.689 17.8856 16.7519C17.8614 16.8149 17.8249 16.8723 17.7783 16.9208C17.7317 16.9693 17.6759 17.0078 17.6142 17.0341C17.5525 17.0605 17.4862 17.074 17.4193 17.074C17.3523 17.074 17.286 17.0605 17.2243 17.0342C17.1627 17.0078 17.1059 16.9693 17.0593 16.9208Z"
                        fill="#231F20"
                      />
                      <path
                        d="M15.1974 24.2856H20.3663C20.4989 24.2856 20.6261 24.2325 20.7199 24.1379C20.8137 24.0433 20.8664 23.915 20.8664 23.7812C20.8664 23.6474 20.8137 23.5192 20.7199 23.4246C20.6261 23.33 20.4989 23.2769 20.3663 23.2769H15.1974C15.0648 23.2769 14.9376 23.33 14.8438 23.4246C14.75 23.5192 14.6973 23.6474 14.6973 23.7812C14.6973 23.915 14.75 24.0433 14.8438 24.1379C14.9376 24.2325 15.0648 24.2856 15.1974 24.2856Z"
                        fill="#231F20"
                      />
                      <path
                        d="M14.6973 25.9496C14.6973 26.0833 14.75 26.2116 14.8438 26.3062C14.9376 26.4008 15.0648 26.4539 15.1974 26.4539H26.8662C26.9989 26.4539 27.1261 26.4008 27.2199 26.3062C27.3137 26.2116 27.3664 26.0833 27.3664 25.9496C27.3664 25.8158 27.3137 25.6875 27.2199 25.5929C27.1261 25.4983 26.9989 25.4452 26.8662 25.4452H15.1974C15.0648 25.4452 14.9376 25.4983 14.8438 25.5929C14.75 25.6875 14.6973 25.8158 14.6973 25.9496Z"
                        fill="#231F20"
                      />
                      <path
                        d="M26.8662 27.6136H15.1974C15.0648 27.6136 14.9376 27.6668 14.8438 27.7614C14.75 27.856 14.6973 27.9842 14.6973 28.118C14.6973 28.2518 14.75 28.3801 14.8438 28.4747C14.9376 28.5692 15.0648 28.6224 15.1974 28.6224H26.8662C26.9989 28.6224 27.1261 28.5692 27.2199 28.4747C27.3137 28.3801 27.3664 28.2518 27.3664 28.118C27.3664 27.9842 27.3137 27.856 27.2199 27.7614C27.1261 27.6668 26.9989 27.6136 26.8662 27.6136Z"
                        fill="#231F20"
                      />
                      <path
                        d="M10.4795 21.5632H12.0548V29.4732C12.054 30.1415 12.3161 30.7829 12.7836 31.2566C13.2512 31.7303 13.8859 31.9976 14.5486 32H27.5249C27.8523 31.9984 28.1761 31.9318 28.4779 31.804C28.7797 31.6761 29.0536 31.4895 29.2838 31.2548C29.5141 31.0201 29.6962 30.742 29.8198 30.4363C29.9433 30.1306 30.0059 29.8033 30.004 29.4732V14.0563C30.0074 13.9268 29.9604 13.801 29.873 13.7059L24.5349 8.15588C24.4889 8.10675 24.4335 8.06759 24.3721 8.04079C24.3106 8.01399 24.2444 8.00011 24.1775 8H14.5437C13.881 8.00263 13.2463 8.27023 12.779 8.74411C12.3117 9.21799 12.0498 9.85945 12.0508 10.5278V12.4877H10.4805C10.4158 12.4881 10.3518 12.5017 10.2924 12.5275C10.233 12.5534 10.1793 12.591 10.1345 12.6381C10.0897 12.6852 10.0547 12.7408 10.0316 12.8018C10.0086 12.8628 9.99781 12.9278 10 12.993V21.0797C9.99813 21.1437 10.0092 21.2074 10.0327 21.2669C10.0561 21.3263 10.0914 21.3804 10.1363 21.4256C10.1812 21.4708 10.2348 21.5062 10.2939 21.5297C10.3529 21.5532 10.4161 21.5643 10.4795 21.5622V21.5632ZM24.7003 9.75336L28.3431 13.546H25.1807C25.1165 13.5463 25.0529 13.5336 24.9936 13.5086C24.9344 13.4836 24.8807 13.4469 24.8358 13.4006C24.7909 13.3543 24.7557 13.2994 24.7322 13.2391C24.7088 13.1788 24.6976 13.1143 24.6993 13.0496L24.7003 9.75336ZM13.0521 10.5278C13.0508 10.1267 13.2073 9.74154 13.4874 9.45675C13.7674 9.17196 14.148 9.01083 14.5457 9.00873H23.7019V13.0486C23.6997 13.2456 23.7363 13.4411 23.8095 13.6237C23.8827 13.8063 23.9912 13.9725 24.1285 14.1126C24.2659 14.2527 24.4294 14.3639 24.6097 14.4398C24.79 14.5157 24.9834 14.5548 25.1787 14.5548H29.0017V29.4732C29.0039 29.6708 28.9675 29.8669 28.8944 30.0503C28.8213 30.2336 28.7131 30.4007 28.5759 30.5418C28.4387 30.6829 28.2753 30.7953 28.0949 30.8726C27.9146 30.9499 27.7209 30.9906 27.5249 30.9923H14.5437C14.1464 30.9896 13.7662 30.8283 13.4867 30.5435C13.2071 30.2588 13.0508 29.8739 13.0521 29.4732V21.5632H20.5287C20.6615 21.5689 20.791 21.5213 20.889 21.4309C20.9869 21.3404 21.0454 21.2145 21.0515 21.0807V12.993C21.0462 12.8569 20.9887 12.7282 20.8912 12.634C20.7937 12.5397 20.6638 12.4873 20.5287 12.4877H13.0521V10.5278ZM11.0003 13.4964H20.0503V20.5555H11.0003V13.4964Z"
                        fill="#231F20"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_969_9681">
                        <rect
                          width="20"
                          height="24"
                          fill="white"
                          transform="translate(10 8)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            ) : (
              <div>
                {/* <img src={base_apis + files.default} alt="img" /> */}
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    opacity="0.4"
                    cx="20"
                    cy="20"
                    r="20"
                    fill="#082240"
                  />
                  <g clip-path="url(#clip0_969_9681)">
                    <path
                      d="M29.5205 14.0564V29.4723C29.5205 29.7371 29.4688 29.9993 29.3683 30.2439C29.2678 30.4886 29.1205 30.7109 28.9349 30.8981C28.7492 31.0854 28.5287 31.2339 28.2861 31.3352C28.0435 31.4366 27.7835 31.4887 27.5209 31.4887H14.5437C14.0133 31.4887 13.5047 31.2763 13.1297 30.8981C12.7547 30.52 12.5441 30.0071 12.5441 29.4723V21.0798H20.5267V12.9931H12.5441V10.5268C12.5441 9.99204 12.7547 9.47915 13.1297 9.10099C13.5047 8.72282 14.0133 8.51038 14.5437 8.51038H24.1804L24.2306 8.562L24.1804 8.61065V13.0477C24.1802 13.1802 24.206 13.3114 24.2563 13.4338C24.3065 13.5563 24.3802 13.6675 24.4731 13.7612C24.566 13.8549 24.6763 13.9292 24.7977 13.9799C24.9191 14.0305 25.0493 14.0565 25.1807 14.0564H29.4201L29.4713 14.0058L29.5205 14.0564Z"
                      fill="#00ACEA"
                    />
                    <path
                      d="M29.4733 14.0067L29.4221 14.0574H25.1807C25.0493 14.0575 24.9192 14.0315 24.7978 13.9808C24.6764 13.9302 24.566 13.8559 24.4731 13.7622C24.3802 13.6685 24.3065 13.5572 24.2563 13.4348C24.2061 13.3124 24.1803 13.1811 24.1804 13.0486V8.61359L24.2306 8.56494L29.4733 14.0067Z"
                      fill="#FEDB41"
                    />
                    <path
                      d="M20.5277 12.993V21.0798H10.4795V12.993H20.5277Z"
                      fill="#00EFD1"
                    />
                    <path
                      d="M17.0593 16.9208L15.9999 15.8853V19.3543C15.9999 19.488 15.9472 19.6163 15.8534 19.7109C15.7596 19.8055 15.6324 19.8586 15.4997 19.8586C15.3671 19.8586 15.2399 19.8055 15.1461 19.7109C15.0523 19.6163 14.9996 19.488 14.9996 19.3543V15.8843L13.9402 16.9198C13.8442 17.0082 13.7178 17.0553 13.5879 17.0513C13.4579 17.0473 13.3346 16.9924 13.2441 16.8983C13.1536 16.8042 13.103 16.6783 13.103 16.5472C13.103 16.4161 13.1536 16.2901 13.2442 16.196L15.1532 14.3325C15.2465 14.2413 15.3713 14.1903 15.5012 14.1903C15.6311 14.1903 15.756 14.2413 15.8493 14.3325L17.7563 16.197C17.8058 16.2425 17.8457 16.2976 17.8737 16.359C17.9017 16.4203 17.9171 16.4867 17.9192 16.5542C17.9212 16.6217 17.9098 16.689 17.8856 16.7519C17.8614 16.8149 17.8249 16.8723 17.7783 16.9208C17.7317 16.9693 17.6759 17.0078 17.6142 17.0341C17.5525 17.0605 17.4862 17.074 17.4193 17.074C17.3523 17.074 17.286 17.0605 17.2243 17.0342C17.1627 17.0078 17.1059 16.9693 17.0593 16.9208Z"
                      fill="#231F20"
                    />
                    <path
                      d="M15.1974 24.2856H20.3663C20.4989 24.2856 20.6261 24.2325 20.7199 24.1379C20.8137 24.0433 20.8664 23.915 20.8664 23.7812C20.8664 23.6474 20.8137 23.5192 20.7199 23.4246C20.6261 23.33 20.4989 23.2769 20.3663 23.2769H15.1974C15.0648 23.2769 14.9376 23.33 14.8438 23.4246C14.75 23.5192 14.6973 23.6474 14.6973 23.7812C14.6973 23.915 14.75 24.0433 14.8438 24.1379C14.9376 24.2325 15.0648 24.2856 15.1974 24.2856Z"
                      fill="#231F20"
                    />
                    <path
                      d="M14.6973 25.9496C14.6973 26.0833 14.75 26.2116 14.8438 26.3062C14.9376 26.4008 15.0648 26.4539 15.1974 26.4539H26.8662C26.9989 26.4539 27.1261 26.4008 27.2199 26.3062C27.3137 26.2116 27.3664 26.0833 27.3664 25.9496C27.3664 25.8158 27.3137 25.6875 27.2199 25.5929C27.1261 25.4983 26.9989 25.4452 26.8662 25.4452H15.1974C15.0648 25.4452 14.9376 25.4983 14.8438 25.5929C14.75 25.6875 14.6973 25.8158 14.6973 25.9496Z"
                      fill="#231F20"
                    />
                    <path
                      d="M26.8662 27.6136H15.1974C15.0648 27.6136 14.9376 27.6668 14.8438 27.7614C14.75 27.856 14.6973 27.9842 14.6973 28.118C14.6973 28.2518 14.75 28.3801 14.8438 28.4747C14.9376 28.5692 15.0648 28.6224 15.1974 28.6224H26.8662C26.9989 28.6224 27.1261 28.5692 27.2199 28.4747C27.3137 28.3801 27.3664 28.2518 27.3664 28.118C27.3664 27.9842 27.3137 27.856 27.2199 27.7614C27.1261 27.6668 26.9989 27.6136 26.8662 27.6136Z"
                      fill="#231F20"
                    />
                    <path
                      d="M10.4795 21.5632H12.0548V29.4732C12.054 30.1415 12.3161 30.7829 12.7836 31.2566C13.2512 31.7303 13.8859 31.9976 14.5486 32H27.5249C27.8523 31.9984 28.1761 31.9318 28.4779 31.804C28.7797 31.6761 29.0536 31.4895 29.2838 31.2548C29.5141 31.0201 29.6962 30.742 29.8198 30.4363C29.9433 30.1306 30.0059 29.8033 30.004 29.4732V14.0563C30.0074 13.9268 29.9604 13.801 29.873 13.7059L24.5349 8.15588C24.4889 8.10675 24.4335 8.06759 24.3721 8.04079C24.3106 8.01399 24.2444 8.00011 24.1775 8H14.5437C13.881 8.00263 13.2463 8.27023 12.779 8.74411C12.3117 9.21799 12.0498 9.85945 12.0508 10.5278V12.4877H10.4805C10.4158 12.4881 10.3518 12.5017 10.2924 12.5275C10.233 12.5534 10.1793 12.591 10.1345 12.6381C10.0897 12.6852 10.0547 12.7408 10.0316 12.8018C10.0086 12.8628 9.99781 12.9278 10 12.993V21.0797C9.99813 21.1437 10.0092 21.2074 10.0327 21.2669C10.0561 21.3263 10.0914 21.3804 10.1363 21.4256C10.1812 21.4708 10.2348 21.5062 10.2939 21.5297C10.3529 21.5532 10.4161 21.5643 10.4795 21.5622V21.5632ZM24.7003 9.75336L28.3431 13.546H25.1807C25.1165 13.5463 25.0529 13.5336 24.9936 13.5086C24.9344 13.4836 24.8807 13.4469 24.8358 13.4006C24.7909 13.3543 24.7557 13.2994 24.7322 13.2391C24.7088 13.1788 24.6976 13.1143 24.6993 13.0496L24.7003 9.75336ZM13.0521 10.5278C13.0508 10.1267 13.2073 9.74154 13.4874 9.45675C13.7674 9.17196 14.148 9.01083 14.5457 9.00873H23.7019V13.0486C23.6997 13.2456 23.7363 13.4411 23.8095 13.6237C23.8827 13.8063 23.9912 13.9725 24.1285 14.1126C24.2659 14.2527 24.4294 14.3639 24.6097 14.4398C24.79 14.5157 24.9834 14.5548 25.1787 14.5548H29.0017V29.4732C29.0039 29.6708 28.9675 29.8669 28.8944 30.0503C28.8213 30.2336 28.7131 30.4007 28.5759 30.5418C28.4387 30.6829 28.2753 30.7953 28.0949 30.8726C27.9146 30.9499 27.7209 30.9906 27.5249 30.9923H14.5437C14.1464 30.9896 13.7662 30.8283 13.4867 30.5435C13.2071 30.2588 13.0508 29.8739 13.0521 29.4732V21.5632H20.5287C20.6615 21.5689 20.791 21.5213 20.889 21.4309C20.9869 21.3404 21.0454 21.2145 21.0515 21.0807V12.993C21.0462 12.8569 20.9887 12.7282 20.8912 12.634C20.7937 12.5397 20.6638 12.4873 20.5287 12.4877H13.0521V10.5278ZM11.0003 13.4964H20.0503V20.5555H11.0003V13.4964Z"
                      fill="#231F20"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_969_9681">
                      <rect
                        width="20"
                        height="24"
                        fill="white"
                        transform="translate(10 8)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            )}
            {!isImageUploaded ? (
              <div>
                <p className="mb-0 f-14 text-center">{uploadLoader}</p>
                <p className="mb-0 f-14 text-subscription text-center">
                  {imagemessage}
                </p>
              </div>
            ) : (
              <div>
                <p className="mb-0 f-14 text-center">
                  {uploadLoaderImageAttached}
                </p>
                <p className="mb-0 f-14 text-center">
                  {imagemessageImageAttached}
                </p>
              </div>
            )}
          </div>

        </div>
        {/* <div className="img_upd_btn" {...getRootProps()} style={{ marginTop: '2rem' }}>
          <input {...getInputProps()} accept="image/*" type="file" />
          <div className="upload_ss d-flex flex-column justify-content-center align-items-center">
            {!files ? (
              <div>
                <div>
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      opacity="0.4"
                      cx="20"
                      cy="20"
                      r="20"
                      fill="#082240"
                    />
                    <g clip-path="url(#clip0_969_9681)">
                      <path
                        d="M29.5205 14.0564V29.4723C29.5205 29.7371 29.4688 29.9993 29.3683 30.2439C29.2678 30.4886 29.1205 30.7109 28.9349 30.8981C28.7492 31.0854 28.5287 31.2339 28.2861 31.3352C28.0435 31.4366 27.7835 31.4887 27.5209 31.4887H14.5437C14.0133 31.4887 13.5047 31.2763 13.1297 30.8981C12.7547 30.52 12.5441 30.0071 12.5441 29.4723V21.0798H20.5267V12.9931H12.5441V10.5268C12.5441 9.99204 12.7547 9.47915 13.1297 9.10099C13.5047 8.72282 14.0133 8.51038 14.5437 8.51038H24.1804L24.2306 8.562L24.1804 8.61065V13.0477C24.1802 13.1802 24.206 13.3114 24.2563 13.4338C24.3065 13.5563 24.3802 13.6675 24.4731 13.7612C24.566 13.8549 24.6763 13.9292 24.7977 13.9799C24.9191 14.0305 25.0493 14.0565 25.1807 14.0564H29.4201L29.4713 14.0058L29.5205 14.0564Z"
                        fill="#00ACEA"
                      />
                      <path
                        d="M29.4733 14.0067L29.4221 14.0574H25.1807C25.0493 14.0575 24.9192 14.0315 24.7978 13.9808C24.6764 13.9302 24.566 13.8559 24.4731 13.7622C24.3802 13.6685 24.3065 13.5572 24.2563 13.4348C24.2061 13.3124 24.1803 13.1811 24.1804 13.0486V8.61359L24.2306 8.56494L29.4733 14.0067Z"
                        fill="#FEDB41"
                      />
                      <path
                        d="M20.5277 12.993V21.0798H10.4795V12.993H20.5277Z"
                        fill="#00EFD1"
                      />
                      <path
                        d="M17.0593 16.9208L15.9999 15.8853V19.3543C15.9999 19.488 15.9472 19.6163 15.8534 19.7109C15.7596 19.8055 15.6324 19.8586 15.4997 19.8586C15.3671 19.8586 15.2399 19.8055 15.1461 19.7109C15.0523 19.6163 14.9996 19.488 14.9996 19.3543V15.8843L13.9402 16.9198C13.8442 17.0082 13.7178 17.0553 13.5879 17.0513C13.4579 17.0473 13.3346 16.9924 13.2441 16.8983C13.1536 16.8042 13.103 16.6783 13.103 16.5472C13.103 16.4161 13.1536 16.2901 13.2442 16.196L15.1532 14.3325C15.2465 14.2413 15.3713 14.1903 15.5012 14.1903C15.6311 14.1903 15.756 14.2413 15.8493 14.3325L17.7563 16.197C17.8058 16.2425 17.8457 16.2976 17.8737 16.359C17.9017 16.4203 17.9171 16.4867 17.9192 16.5542C17.9212 16.6217 17.9098 16.689 17.8856 16.7519C17.8614 16.8149 17.8249 16.8723 17.7783 16.9208C17.7317 16.9693 17.6759 17.0078 17.6142 17.0341C17.5525 17.0605 17.4862 17.074 17.4193 17.074C17.3523 17.074 17.286 17.0605 17.2243 17.0342C17.1627 17.0078 17.1059 16.9693 17.0593 16.9208Z"
                        fill="#231F20"
                      />
                      <path
                        d="M15.1974 24.2856H20.3663C20.4989 24.2856 20.6261 24.2325 20.7199 24.1379C20.8137 24.0433 20.8664 23.915 20.8664 23.7812C20.8664 23.6474 20.8137 23.5192 20.7199 23.4246C20.6261 23.33 20.4989 23.2769 20.3663 23.2769H15.1974C15.0648 23.2769 14.9376 23.33 14.8438 23.4246C14.75 23.5192 14.6973 23.6474 14.6973 23.7812C14.6973 23.915 14.75 24.0433 14.8438 24.1379C14.9376 24.2325 15.0648 24.2856 15.1974 24.2856Z"
                        fill="#231F20"
                      />
                      <path
                        d="M14.6973 25.9496C14.6973 26.0833 14.75 26.2116 14.8438 26.3062C14.9376 26.4008 15.0648 26.4539 15.1974 26.4539H26.8662C26.9989 26.4539 27.1261 26.4008 27.2199 26.3062C27.3137 26.2116 27.3664 26.0833 27.3664 25.9496C27.3664 25.8158 27.3137 25.6875 27.2199 25.5929C27.1261 25.4983 26.9989 25.4452 26.8662 25.4452H15.1974C15.0648 25.4452 14.9376 25.4983 14.8438 25.5929C14.75 25.6875 14.6973 25.8158 14.6973 25.9496Z"
                        fill="#231F20"
                      />
                      <path
                        d="M26.8662 27.6136H15.1974C15.0648 27.6136 14.9376 27.6668 14.8438 27.7614C14.75 27.856 14.6973 27.9842 14.6973 28.118C14.6973 28.2518 14.75 28.3801 14.8438 28.4747C14.9376 28.5692 15.0648 28.6224 15.1974 28.6224H26.8662C26.9989 28.6224 27.1261 28.5692 27.2199 28.4747C27.3137 28.3801 27.3664 28.2518 27.3664 28.118C27.3664 27.9842 27.3137 27.856 27.2199 27.7614C27.1261 27.6668 26.9989 27.6136 26.8662 27.6136Z"
                        fill="#231F20"
                      />
                      <path
                        d="M10.4795 21.5632H12.0548V29.4732C12.054 30.1415 12.3161 30.7829 12.7836 31.2566C13.2512 31.7303 13.8859 31.9976 14.5486 32H27.5249C27.8523 31.9984 28.1761 31.9318 28.4779 31.804C28.7797 31.6761 29.0536 31.4895 29.2838 31.2548C29.5141 31.0201 29.6962 30.742 29.8198 30.4363C29.9433 30.1306 30.0059 29.8033 30.004 29.4732V14.0563C30.0074 13.9268 29.9604 13.801 29.873 13.7059L24.5349 8.15588C24.4889 8.10675 24.4335 8.06759 24.3721 8.04079C24.3106 8.01399 24.2444 8.00011 24.1775 8H14.5437C13.881 8.00263 13.2463 8.27023 12.779 8.74411C12.3117 9.21799 12.0498 9.85945 12.0508 10.5278V12.4877H10.4805C10.4158 12.4881 10.3518 12.5017 10.2924 12.5275C10.233 12.5534 10.1793 12.591 10.1345 12.6381C10.0897 12.6852 10.0547 12.7408 10.0316 12.8018C10.0086 12.8628 9.99781 12.9278 10 12.993V21.0797C9.99813 21.1437 10.0092 21.2074 10.0327 21.2669C10.0561 21.3263 10.0914 21.3804 10.1363 21.4256C10.1812 21.4708 10.2348 21.5062 10.2939 21.5297C10.3529 21.5532 10.4161 21.5643 10.4795 21.5622V21.5632ZM24.7003 9.75336L28.3431 13.546H25.1807C25.1165 13.5463 25.0529 13.5336 24.9936 13.5086C24.9344 13.4836 24.8807 13.4469 24.8358 13.4006C24.7909 13.3543 24.7557 13.2994 24.7322 13.2391C24.7088 13.1788 24.6976 13.1143 24.6993 13.0496L24.7003 9.75336ZM13.0521 10.5278C13.0508 10.1267 13.2073 9.74154 13.4874 9.45675C13.7674 9.17196 14.148 9.01083 14.5457 9.00873H23.7019V13.0486C23.6997 13.2456 23.7363 13.4411 23.8095 13.6237C23.8827 13.8063 23.9912 13.9725 24.1285 14.1126C24.2659 14.2527 24.4294 14.3639 24.6097 14.4398C24.79 14.5157 24.9834 14.5548 25.1787 14.5548H29.0017V29.4732C29.0039 29.6708 28.9675 29.8669 28.8944 30.0503C28.8213 30.2336 28.7131 30.4007 28.5759 30.5418C28.4387 30.6829 28.2753 30.7953 28.0949 30.8726C27.9146 30.9499 27.7209 30.9906 27.5249 30.9923H14.5437C14.1464 30.9896 13.7662 30.8283 13.4867 30.5435C13.2071 30.2588 13.0508 29.8739 13.0521 29.4732V21.5632H20.5287C20.6615 21.5689 20.791 21.5213 20.889 21.4309C20.9869 21.3404 21.0454 21.2145 21.0515 21.0807V12.993C21.0462 12.8569 20.9887 12.7282 20.8912 12.634C20.7937 12.5397 20.6638 12.4873 20.5287 12.4877H13.0521V10.5278ZM11.0003 13.4964H20.0503V20.5555H11.0003V13.4964Z"
                        fill="#231F20"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_969_9681">
                        <rect
                          width="20"
                          height="24"
                          fill="white"
                          transform="translate(10 8)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            ) : (
              <div>
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    opacity="0.4"
                    cx="20"
                    cy="20"
                    r="20"
                    fill="#082240"
                  />
                  <g clip-path="url(#clip0_969_9681)">
                    <path
                      d="M29.5205 14.0564V29.4723C29.5205 29.7371 29.4688 29.9993 29.3683 30.2439C29.2678 30.4886 29.1205 30.7109 28.9349 30.8981C28.7492 31.0854 28.5287 31.2339 28.2861 31.3352C28.0435 31.4366 27.7835 31.4887 27.5209 31.4887H14.5437C14.0133 31.4887 13.5047 31.2763 13.1297 30.8981C12.7547 30.52 12.5441 30.0071 12.5441 29.4723V21.0798H20.5267V12.9931H12.5441V10.5268C12.5441 9.99204 12.7547 9.47915 13.1297 9.10099C13.5047 8.72282 14.0133 8.51038 14.5437 8.51038H24.1804L24.2306 8.562L24.1804 8.61065V13.0477C24.1802 13.1802 24.206 13.3114 24.2563 13.4338C24.3065 13.5563 24.3802 13.6675 24.4731 13.7612C24.566 13.8549 24.6763 13.9292 24.7977 13.9799C24.9191 14.0305 25.0493 14.0565 25.1807 14.0564H29.4201L29.4713 14.0058L29.5205 14.0564Z"
                      fill="#00ACEA"
                    />
                    <path
                      d="M29.4733 14.0067L29.4221 14.0574H25.1807C25.0493 14.0575 24.9192 14.0315 24.7978 13.9808C24.6764 13.9302 24.566 13.8559 24.4731 13.7622C24.3802 13.6685 24.3065 13.5572 24.2563 13.4348C24.2061 13.3124 24.1803 13.1811 24.1804 13.0486V8.61359L24.2306 8.56494L29.4733 14.0067Z"
                      fill="#FEDB41"
                    />
                    <path
                      d="M20.5277 12.993V21.0798H10.4795V12.993H20.5277Z"
                      fill="#00EFD1"
                    />
                    <path
                      d="M17.0593 16.9208L15.9999 15.8853V19.3543C15.9999 19.488 15.9472 19.6163 15.8534 19.7109C15.7596 19.8055 15.6324 19.8586 15.4997 19.8586C15.3671 19.8586 15.2399 19.8055 15.1461 19.7109C15.0523 19.6163 14.9996 19.488 14.9996 19.3543V15.8843L13.9402 16.9198C13.8442 17.0082 13.7178 17.0553 13.5879 17.0513C13.4579 17.0473 13.3346 16.9924 13.2441 16.8983C13.1536 16.8042 13.103 16.6783 13.103 16.5472C13.103 16.4161 13.1536 16.2901 13.2442 16.196L15.1532 14.3325C15.2465 14.2413 15.3713 14.1903 15.5012 14.1903C15.6311 14.1903 15.756 14.2413 15.8493 14.3325L17.7563 16.197C17.8058 16.2425 17.8457 16.2976 17.8737 16.359C17.9017 16.4203 17.9171 16.4867 17.9192 16.5542C17.9212 16.6217 17.9098 16.689 17.8856 16.7519C17.8614 16.8149 17.8249 16.8723 17.7783 16.9208C17.7317 16.9693 17.6759 17.0078 17.6142 17.0341C17.5525 17.0605 17.4862 17.074 17.4193 17.074C17.3523 17.074 17.286 17.0605 17.2243 17.0342C17.1627 17.0078 17.1059 16.9693 17.0593 16.9208Z"
                      fill="#231F20"
                    />
                    <path
                      d="M15.1974 24.2856H20.3663C20.4989 24.2856 20.6261 24.2325 20.7199 24.1379C20.8137 24.0433 20.8664 23.915 20.8664 23.7812C20.8664 23.6474 20.8137 23.5192 20.7199 23.4246C20.6261 23.33 20.4989 23.2769 20.3663 23.2769H15.1974C15.0648 23.2769 14.9376 23.33 14.8438 23.4246C14.75 23.5192 14.6973 23.6474 14.6973 23.7812C14.6973 23.915 14.75 24.0433 14.8438 24.1379C14.9376 24.2325 15.0648 24.2856 15.1974 24.2856Z"
                      fill="#231F20"
                    />
                    <path
                      d="M14.6973 25.9496C14.6973 26.0833 14.75 26.2116 14.8438 26.3062C14.9376 26.4008 15.0648 26.4539 15.1974 26.4539H26.8662C26.9989 26.4539 27.1261 26.4008 27.2199 26.3062C27.3137 26.2116 27.3664 26.0833 27.3664 25.9496C27.3664 25.8158 27.3137 25.6875 27.2199 25.5929C27.1261 25.4983 26.9989 25.4452 26.8662 25.4452H15.1974C15.0648 25.4452 14.9376 25.4983 14.8438 25.5929C14.75 25.6875 14.6973 25.8158 14.6973 25.9496Z"
                      fill="#231F20"
                    />
                    <path
                      d="M26.8662 27.6136H15.1974C15.0648 27.6136 14.9376 27.6668 14.8438 27.7614C14.75 27.856 14.6973 27.9842 14.6973 28.118C14.6973 28.2518 14.75 28.3801 14.8438 28.4747C14.9376 28.5692 15.0648 28.6224 15.1974 28.6224H26.8662C26.9989 28.6224 27.1261 28.5692 27.2199 28.4747C27.3137 28.3801 27.3664 28.2518 27.3664 28.118C27.3664 27.9842 27.3137 27.856 27.2199 27.7614C27.1261 27.6668 26.9989 27.6136 26.8662 27.6136Z"
                      fill="#231F20"
                    />
                    <path
                      d="M10.4795 21.5632H12.0548V29.4732C12.054 30.1415 12.3161 30.7829 12.7836 31.2566C13.2512 31.7303 13.8859 31.9976 14.5486 32H27.5249C27.8523 31.9984 28.1761 31.9318 28.4779 31.804C28.7797 31.6761 29.0536 31.4895 29.2838 31.2548C29.5141 31.0201 29.6962 30.742 29.8198 30.4363C29.9433 30.1306 30.0059 29.8033 30.004 29.4732V14.0563C30.0074 13.9268 29.9604 13.801 29.873 13.7059L24.5349 8.15588C24.4889 8.10675 24.4335 8.06759 24.3721 8.04079C24.3106 8.01399 24.2444 8.00011 24.1775 8H14.5437C13.881 8.00263 13.2463 8.27023 12.779 8.74411C12.3117 9.21799 12.0498 9.85945 12.0508 10.5278V12.4877H10.4805C10.4158 12.4881 10.3518 12.5017 10.2924 12.5275C10.233 12.5534 10.1793 12.591 10.1345 12.6381C10.0897 12.6852 10.0547 12.7408 10.0316 12.8018C10.0086 12.8628 9.99781 12.9278 10 12.993V21.0797C9.99813 21.1437 10.0092 21.2074 10.0327 21.2669C10.0561 21.3263 10.0914 21.3804 10.1363 21.4256C10.1812 21.4708 10.2348 21.5062 10.2939 21.5297C10.3529 21.5532 10.4161 21.5643 10.4795 21.5622V21.5632ZM24.7003 9.75336L28.3431 13.546H25.1807C25.1165 13.5463 25.0529 13.5336 24.9936 13.5086C24.9344 13.4836 24.8807 13.4469 24.8358 13.4006C24.7909 13.3543 24.7557 13.2994 24.7322 13.2391C24.7088 13.1788 24.6976 13.1143 24.6993 13.0496L24.7003 9.75336ZM13.0521 10.5278C13.0508 10.1267 13.2073 9.74154 13.4874 9.45675C13.7674 9.17196 14.148 9.01083 14.5457 9.00873H23.7019V13.0486C23.6997 13.2456 23.7363 13.4411 23.8095 13.6237C23.8827 13.8063 23.9912 13.9725 24.1285 14.1126C24.2659 14.2527 24.4294 14.3639 24.6097 14.4398C24.79 14.5157 24.9834 14.5548 25.1787 14.5548H29.0017V29.4732C29.0039 29.6708 28.9675 29.8669 28.8944 30.0503C28.8213 30.2336 28.7131 30.4007 28.5759 30.5418C28.4387 30.6829 28.2753 30.7953 28.0949 30.8726C27.9146 30.9499 27.7209 30.9906 27.5249 30.9923H14.5437C14.1464 30.9896 13.7662 30.8283 13.4867 30.5435C13.2071 30.2588 13.0508 29.8739 13.0521 29.4732V21.5632H20.5287C20.6615 21.5689 20.791 21.5213 20.889 21.4309C20.9869 21.3404 21.0454 21.2145 21.0515 21.0807V12.993C21.0462 12.8569 20.9887 12.7282 20.8912 12.634C20.7937 12.5397 20.6638 12.4873 20.5287 12.4877H13.0521V10.5278ZM11.0003 13.4964H20.0503V20.5555H11.0003V13.4964Z"
                      fill="#231F20"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_969_9681">
                      <rect
                        width="20"
                        height="24"
                        fill="white"
                        transform="translate(10 8)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            )}
            {!isImageUploaded ? (
              <div>
                <p className="mb-0 f-14 text-center">{uploadLoader}</p>
                <p className="mb-0 f-14 text-subscription text-center">
                  {imagemessage}
                </p>
              </div>
            ) : (
              <div>
                <p className="mb-0 f-14 text-center">
                  {uploadLoaderImageAttached}
                </p>
                <p className="mb-0 f-14 text-center">
                  {imagemessageImageAttached}
                </p>
              </div>
            )}
          </div>
        </div> */}
      </div>
      {
        isPremiumUsers === true ? <div className="mt-4">
          <Button text={"request a callback"} onClick={() => { handleSubmitBtn(true) }} />
        </div> : <></>
      }

      <div className="mt-4">
        {/* <button onClick={handleSubmitBtn} className="submit-button crm-submit">submit</button> */}
        <button onClick={() => handleSubmitBtn(false)} className={isFormValiate ? "submit-button" : "submit-button crm-submit"}>{t("crm.submit")}</button>
      </div>
      {showRequestSubmitPopup && (
        <RequestSubmitPopup
          isOpen={showRequestSubmitPopup}
          onClose={() => {
            setRequestSubmitPopup(false);
            // navigate(routesFrontend.customerCare);
            navigate(-1);
          }}
          title={""}
          payloadInfo={payloadInfo}
        />
      )}
      {showTimeSlotPopup && (
        <TimeSlotPopup
          isOpen={showTimeSlotPopup}
          timeslotsList={timeslotsList}
          mobileNo={mobileNo}
          onClose={() => {
            setTimeSlotPopup(false);
          }}
          title={"select time slot"}
          onSubmitTimeSlot={(data) => {
            setTimeSlotPopup(false);
            setTimeSlot(data)
          }}
        />
      )}
      {showCallBackMObile && (
        <CallbackMobile
          isOpen={showCallBackMObile}
          onClose={() => {
            setCallBackMObile(false);
          }}
          title={"enter mobile number"}
          onMobileNo={(mobile) => {
            setMobileNo(mobile)
            setCallBackMObile(false);
            fetchTimeSlot();
          }}
        />
      )}
    </div>
  );
};

export default RaiseAComplaint;
